"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newAttributeMetadataObject = exports.AttributeMetadataObjectBuilder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var factory_1 = require("./factory");
var builder_1 = require("../builder");
/**
 * Attribute metadata object builder
 * See {@link Builder}
 *
 * @beta
 */
var AttributeMetadataObjectBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(AttributeMetadataObjectBuilder, _super);
    function AttributeMetadataObjectBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AttributeMetadataObjectBuilder.prototype.drillDownStep = function (ref) {
        if (ref) {
            this.item.drillDownStep = ref;
        }
        return this;
    };
    AttributeMetadataObjectBuilder.prototype.drillToAttributeLink = function (ref) {
        if (ref) {
            this.item.drillToAttributeLink = ref;
        }
        return this;
    };
    AttributeMetadataObjectBuilder.prototype.displayForms = function (displayForms) {
        this.item.displayForms = displayForms;
        return this;
    };
    return AttributeMetadataObjectBuilder;
}(factory_1.MetadataObjectBuilder));
exports.AttributeMetadataObjectBuilder = AttributeMetadataObjectBuilder;
/**
 * Attribute metadata object factory
 *
 * @param ref - attribute reference
 * @param modifications - attribute builder modifications to perform
 * @returns created attribute metadata object
 * @beta
 */
exports.newAttributeMetadataObject = function (ref, modifications) {
    if (modifications === void 0) { modifications = identity_1.default; }
    return builder_1.builderFactory(AttributeMetadataObjectBuilder, { type: "attribute", ref: ref }, modifications);
};
//# sourceMappingURL=attributeFactory.js.map